export const portfolioData = {
  personalInfo: {
    name: "Zakariae AHMEDLAAZIZ",
    title: {
      en: "Computer Engineer",
      fr: "Ingénieur informatique & junior DevOps"
    },
    location: { en: "Casablanca, Morocco", fr: "Casablanca, Maroc" },
    email: "zakariaeahmedlaaziz@gmail.com",
    phone: "+212-611903945",
    bio: {
      en: "I build robust web applications, streamline workflows through automation, and enhance software quality with continuous improvement — all while maintaining a strong emphasis on design and user experience",
      fr: "Je conçois des applications web robustes, j’optimise les flux par l’automatisation et j’améliore la qualité logicielle dans une démarche d’amélioration continue — tout en conservant un fort accent sur le design et l’expérience utilisateur"
    },
    image: "whitebackground.png"
  },
  socialLinks: [
    {
      name: "GitHub",
      url: "https://github.com/Zakariae4AL",
      icon: "FaGithub"
    },
    {
      name: "LinkedIn",
      url: "https://www.linkedin.com/in/zakariae-ahmedlaaziz-3308b72b6/",
      icon: "FaLinkedin"
    },
    {
      name: "Twitter",
      url: "https://twitter.com",
      icon: "FaTwitter"
    },
    {
      name: "Email",
      url: "mailto:john.doe@example.com",
      icon: "FaEnvelope"
    }
  ],
  skills: [
    {
      category: "Frontend",
      items: [
        { name: "React", level: 90 },
        { name: "JavaScript", level: 95 },
        { name: "TypeScript", level: 85 },
        { name: "HTML/CSS", level: 95 },
        { name: "Tailwind CSS", level: 90 },
        { name: "Next.js", level: 85 },
        { name: "React Native", level: 80 },
        { name: "Angular", level: 75 },
        { name: "Redux", level: 80 },
        { name: "Flutter", level: 70 },
        { name: "NativeWind CSS", level: 70 }
      ]
    },
    {
      category: "Backend",
      items: [
        { name: "Node.js", level: 90 },
        { name: "Python", level: 80 },
        { name: "REST APIs", level: 90 },
        { name: "Spring Boot", level: 80 },
        { name: "Java", level: 80 },
        { name: "PHP", level: 70 },
        { name: "JEE", level: 70 },
        { name: "C# (.NET)", level: 65 },
        { name: "C++", level: 60 },
        { name: "Flask", level: 65 },
        { name: "Flutter", level: 60 }
      ]
    },
    {
      category: "Tools & Others",
      items: [
        { name: "Git", level: 90 },
        { name: "GitHub", level: 90 },
        { name: "Linux", level: 75 },
        { name: "Scripting Shell", level: 70 },
        { name: "Script bash", level: 70 },
        { name: "Docker", level: 80 },
        { name: "CI/CD", level: 85 },
        { name: "Jenkins", level: 75 },
        { name: "Jira", level: 80 },
        { name: "Kanban", level: 80 },
        { name: "Trello", level: 75 },
        { name: "Gantt", level: 65 },
        { name: "Canva", level: 70 },
        { name: "PowerAMC", level: 70 },
        { name: "Odoo", level: 60 },
        { name: "Postman", level: 85 },
        { name: "Microsoft Azure", level: 70 },
        { name: "AWS", level: 80 },
        { name: "SonarCloud", level: 65 },
        { name: "Selenium", level: 65 },
        { name: "Selenium IDE", level: 60 },
        { name: "JMeter", level: 70 },
        { name: "Aiven", level: 60 }
      ]
    },
    {
      category: "Databases",
      items: [
        { name: "PostgreSQL", level: 85 },
        { name: "MongoDB", level: 80 },
        { name: "SQL Server", level: 75 },
        { name: "MySQL", level: 80 },
        { name: "Oracle", level: 70 },
        { name: "SQLite", level: 70 },
        { name: "Data Warehouse", level: 60 },
        { name: "Supabase", level: 70 },
        { name: "Firebase", level: 75 },
        { name: "MySQL Workbench", level: 70 },
        { name: "Database Administration", level: 75 }
      ]
    }
    ,
    {
      category: "Data Engineering & IA",
      items: [
        { name: "Pandas", level: 80 },
        { name: "NumPy", level: 80 },
        { name: "Scikit-learn", level: 75 },
        { name: "TensorFlow (bases)", level: 60 },
        { name: "Collecte et nettoyage des données", level: 80 },
        { name: "Analyse exploratoire", level: 75 },
        { name: "Visualisation (Matplotlib, Power BI)", level: 75 },
        { name: "RAG", level: 60 },
        { name: "Ollama", level: 60 },
        { name: "Mistral", level: 60 },
        { name: "LLaMA 3.2", level: 55 }
      ]
    }
    ,
    {
      category: "Tests & Qualité Logicielle",
      items: [
        { name: "Selenium IDE", level: 60 },
        { name: "Selenium", level: 65 },
        { name: "JMeter", level: 70 },
        { name: "SonarQube", level: 70 },
        
      ]
    }
  ],
  projects: [
    {
      id: 0,
      title: "Déploiement d’un Site Web et Application Mobile Full Stack de gestion des patrimoines Innovante avec IA Intégrée et Conteneurisation Docker",
      description: "Plateforme full stack (web + mobile) de gestion des patrimoines avec IA intégrée et déploiement conteneurisé.",
      details: "Développement et déploiement d’un site web et d’une application mobile full stack de gestion des patrimoines innovante intégrant l’IA.\n\nFrontend réalisé avec React (web) et React Native (mobile) pour une expérience utilisateur fluide et moderne.\n\nBackend Spring Boot connecté à une base de données MySQL pour la gestion sécurisée des données.\n\nIA intégrée via Ollama et Mistral pour l’analyse intelligente et les recommandations automatisées.\n\nConteneurisation et orchestration avec Docker et Docker Compose, assurant portabilité et déploiement simplifié.\n\nAdoption des pratiques DevOps (SonarQube, CI/CD, tests automatisés avec Selenium) et méthode Scrum pour une gestion agile du projet.",
      note: "Note: Projet privé pour des raisons de confidentialité (destiné au Maroc).",
      image: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=800&h=600&fit=crop",
      technologies: [
        "React",
        "React Native",
        "Spring Boot",
        "MySQL",
        "Ollama",
        "Mistral",
        "Docker",
        "Docker Compose",
        "CI/CD",
        "SonarQube",
        "Selenium",
        "Scrum"
      ],
      githubUrl: "https://github.com/Zakariae4AL/PFE_gestion_des_patrimoines_ai",
      liveUrl: ""
    },
    {
      id: 100,
      title: "Localisation en temps réel des ambulances et optimisation des itinéraires",
      description: "Projet de localisation en temps réel des ambulances et d’optimisation des itinéraires pour le transport des patients.",
      details: "Projet de localisation en temps réel des ambulances et d’optimisation des itinéraires pour le transport des patients.\n\nArchitecture microservices avec modularité, évolutivité et maintenabilité, comprenant plusieurs services dédiés (ambulances, trajets, hôpitaux, utilisateurs).\n\nFrontend Angular 18 pour le web et Flutter pour l’application mobile offrant cartes interactives et suivi GPS.\n\nBackend Spring Boot 3 avec gestion sécurisée des utilisateurs, rôles et assignation automatique des trajets.\n\nBases de données MongoDB et PostgreSQL, intégration via API Gateway et découverte de services avec Eureka Server.\n\nConteneurisation et DevOps avec Docker/Docker Compose pour le déploiement, CI/CD et orchestration des services.",
      note: "Note: Projet privé pour des raisons de confidentialité (destiné au Maroc).",
      image: "https://images.unsplash.com/photo-1531907700752-62799b2a26db?w=800&h=600&fit=crop",
      technologies: [
        "Angular 18",
        "Flutter",
        "Spring Boot 3",
        "MongoDB",
        "PostgreSQL",
        "Eureka Server",
        "API Gateway",
        "Docker",
        "Docker Compose",
        "CI/CD"
      ],
      githubUrl: "https://github.com/optimiser-itineraires-des-ambulances/----README-FILE----",
      liveUrl: ""
    },
    {
      id: 1,
      title: "Projet Data Mining - Prédiction des Maladies Cardiaques",
      description: "Projet de Data Mining visant à prédire les maladies cardiaques à partir de données cliniques.",
      details: "Projet de Data Mining visant à prédire les maladies cardiaques à partir de données cliniques.\n\nJeu de données combiné (Statlog, Cleveland, Hungary) contenant des informations comme âge, sexe, cholestérol, fréquence cardiaque, etc.\n\nMéthodes utilisées : SVM, Naive Bayes, Firefly Algorithm et Recursive Feature Elimination (RFE).\n\nMeilleure performance : 92.16 % de précision avec la combinaison RFE + Firefly Algorithm.\n\nScripts et notebooks Python/Jupyter pour l’analyse, la sélection de caractéristiques et la visualisation des résultats.\n\nProjet open-source encourageant les contributions et les expérimentations en apprentissage automatique.",
      image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&h=600&fit=crop",
      technologies: [
        "Python",
        "Jupyter Notebook",
        "Scikit-learn",
        "NumPy & Pandas",
        "Matplotlib & Seaborn",
        "Firefly Algorithm",
        "Git & GitHub"
      ],
      githubUrl: "https://github.com/Zakariae4AL/Projet_Data_Mining",
      liveUrl: "https://example.com"
    },
    {
      id: 2,
      title: "Modèle de Prédiction de la Température",
      description: "Projet de régression linéaire simple visant à prédire la température du lendemain en fonction du jour de la semaine.",
      details: "Projet de régression linéaire simple visant à prédire la température du lendemain en fonction du jour de la semaine.\n\nUtilise un petit jeu de données météorologiques (weather_data.csv) contenant les jours et températures enregistrées.\n\nLe modèle est développé en Python et exécuté sur Google Colab.\n\nLes étapes incluent le prétraitement des données, l’entraînement du modèle, l’évaluation via MSE, et la visualisation des résultats.\n\nFournit une base pour comprendre la construction et l’évaluation d’un modèle de régression linéaire.\n\nTechnologies et bibliothèques utilisées : Python, Google Colab, Pandas, Matplotlib, Scikit-learn.",
      image: "https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=800&h=600&fit=crop",
      technologies: [
        "Python",
        "Google Colab",
        "Pandas",
        "Matplotlib",
        "Scikit-learn"
      ],
      githubUrl: "https://github.com/Zakariae4AL/Model-Prediction-Temperature",
      liveUrl: ""
    },
    {
      id: 3,
      title: "Kanban Application Mobile",
      description: "Application mobile Kanban pour la gestion de tâches via tableaux, listes et cartes.",
      details: "Application mobile Kanban, permettant la gestion de tâches via des tableaux, listes et cartes interactives.\n\nDéveloppée avec React Native pour une expérience fluide et multiplateforme sur Android.\n\nBackend Spring Boot assurant la gestion des utilisateurs, des projets, et des tâches via une API REST sécurisée.\n\nBase de données relationnelle (MySQL ou PostgreSQL) pour le stockage persistant des données.\n\nIntègre des fonctionnalités de drag-and-drop, mise à jour en temps réel et notifications.\n\nTechnologies utilisées : React Native, Java (Spring Boot), REST API, MySQL/PostgreSQL, Axios, JSON.",
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop",
      technologies: [
        "React Native",
        "Spring Boot",
        "REST API",
        "MySQL/PostgreSQL",
        "Axios",
        "JSON"
      ],
      githubUrl: "https://github.com/Zakariae4AL/Kanban-Application-Mobile/tree/master",
      liveUrl: ""
    },
    {
      id: 4,
      title: "Kanban Site Web",
      description: "Site web Kanban pour la gestion de projets via tableaux, listes et cartes collaboratives.",
      details: "Site web Kanban, permettant la gestion de projets via des tableaux, listes et cartes collaboratives.\n\nFrontend en React.js offrant une interface moderne, réactive et intuitive pour la gestion des tâches.\n\nBackend en Spring Boot exposant des API REST sécurisées pour l’authentification, la gestion des utilisateurs et des projets.\n\nBase de données MySQL/PostgreSQL utilisée pour le stockage persistant et la gestion des relations entre entités.\n\nIntégration de pratiques DevOps : CI/CD avec Docker, GitHub Actions et déploiement automatisé.\n\nTests unitaires et d’intégration mis en place avec JUnit, Jest et Postman pour garantir la fiabilité du système.",
      image: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=800&h=600&fit=crop",
      technologies: [
        "React.js",
        "Spring Boot",
        "REST API",
        "MySQL/PostgreSQL",
        "Docker",
        "GitHub Actions",
        "CI/CD",
        "JUnit",
        "Jest",
        "Postman"
      ],
      githubUrl: "https://github.com/Zakariae4AL/Latest-Kanban-Projet",
      liveUrl: ""
    },
    {
      id: 5,
      title: "Réservation des Salles",
      description: "Application web de réservation de salles avec gestion, planification et disponibilités en temps réel.",
      details: "Application web de réservation de salles permettant la gestion, la planification et la visualisation des disponibilités en temps réel.\n\nFrontend développé en Angular pour une interface dynamique, réactive et facile à utiliser.\n\nBackend Spring Boot assurant la gestion des réservations, des utilisateurs et des créneaux via des API REST sécurisées.\n\nBase de données relationnelle (MySQL ou PostgreSQL) pour le stockage fiable des données de réservation.\n\nIntégration de pratiques DevOps avec Docker, CI/CD et supervision du code via SonarQube.\n\nMise en place de tests unitaires et d’intégration avec JUnit, Jasmine et Postman pour garantir la qualité et la stabilité du système.",
      image: "https://images.unsplash.com/photo-1557800636-894a64c1696f?w=800&h=600&fit=crop",
      technologies: [
        "Angular",
        "Spring Boot",
        "REST API",
        "MySQL/PostgreSQL",
        "Docker",
        "CI/CD",
        "SonarQube",
        "JUnit",
        "Postman"
      ],
      githubUrl: "https://github.com/Zakariae4AL/Reservation_des_salles/tree/Frontend",
      liveUrl: ""
    },
    {
      id: 6,
      title: "Application web d’échange de services",
      description: "Plateforme d’échange de services reliant utilisateurs pour proposer/demander des prestations.",
      details: "Application web d’échange de services facilitant la mise en relation entre utilisateurs pour proposer ou demander des prestations.\n\nFrontend Angular offrant une interface claire et interactive pour la gestion des offres et des demandes.\n\nBackend Spring Boot fournissant des API REST sécurisées pour la gestion des utilisateurs, des services et des transactions.\n\nBase de données MySQL/PostgreSQL assurant le stockage structuré et fiable des informations.\n\nIntégration des pratiques DevOps avec Docker, CI/CD et analyse de code via SonarQube.\n\nTests unitaires et d’intégration réalisés avec JUnit et Postman pour garantir la qualité et la fiabilité du projet.",
      image: "https://images.unsplash.com/photo-1557800636-894a64c1696f?w=800&h=600&fit=crop",
      technologies: [
        "Angular",
        "Spring Boot",
        "REST API",
        "MySQL/PostgreSQL",
        "Docker",
        "CI/CD",
        "SonarQube",
        "JUnit",
        "Postman"
      ],
      githubUrl: "https://github.com/Zakariae4AL/Echange_de_services",
      liveUrl: ""
    }
    
    ,
    {
      id: 10,
      title: "Projet Gestion des stagiaires (Admin & Stagiaires)",
      description: "Deux sites web distincts pour administrateurs et stagiaires avec automatisation des documents.",
      details: "Projet Gestion des stagiaires avec deux sites web distincts : un pour les administrateurs et un pour les stagiaires.\n\nTechnologies Frontend/Backend : PHP, HTML, CSS avec authentification JWT et hashing des mots de passe pour la sécurité.\n\nAutomatisation des documents : génération automatique des fichiers pour les stagiaires, nécessitant uniquement la signature du responsable.\n\nInterface moderne, attractive et responsive pour une expérience utilisateur optimale.\n\nAdoption de la méthodologie Scrum/Agile pour la gestion de projet et priorisation des fonctionnalités.\n\nPratiques DevOps mises en place pour le déploiement, l’intégration continue et la maintenance du système.",
      note: "Note: Projet privé pour des raisons de confidentialité (destiné au Maroc).",
      image: "https://images.unsplash.com/photo-1487058792275-0ad4aaf24ca7?w=800&h=600&fit=crop",
      technologies: [
        "PHP",
        "HTML",
        "CSS",
        "JWT Authentication",
        "Password Hashing",
        "Responsive UI",
        "Scrum/Agile",
        "DevOps",
        "CI/CD"
      ],
      githubUrl: "https://github.com/Zakariae4AL/Gestion-stagiaires-Menara-Holding",
      liveUrl: ""
    }
  ],
  experience: [
    {
      position: { en: "Final Year Project Internship", fr: "Stage Projet Fin D’etude" },
      companyName: "Aikini Solutions",
      companyUrl: "https://www.aikini.fr/",
      period: "2025"
    },
    {
      position: { en: "On-site Internship", fr: "Stage présentiel" },
      companyName: "Menara Holding",
      companyUrl: "https://menara-holding.ma/",
      period: "2024"
    },
    {
      position: { en: "On-site Internship", fr: "Stage présentiel" },
      companyName: "OCP Group",
      companyUrl: "https://www.ocpgroup.ma/",
      period: "2022"
    },
    {
      position: { en: "On-site Internship", fr: "Stage présentiel" },
      companyName: "Menara Préfa",
      companyUrl: "https://menaraprefa.ma/",
      period: "2019"
    }
  ],
  education: [
    {
      degree: { en: "Engineering cycle in Computer Engineering", fr: "Cycle d’ingénieur en Génie informatique" },
      school: "EMSI",
      period: "2019 - 2025"
    },
    {
      degree: { en: "Professional Baccalaureate in Computer Maintenance and Networks", fr: "Bac professionnel en Maintenance informatique et réseaux" },
      school: "Université Moulay Ismail",
      period: "2019"
    }
  ],
  certificates: [
    {
      id: 1,
      name: "Python for Everybody",
      issuer: "Coursera",
      date: "",
      credentialId: "",
      credentialUrl: "https://coursera.org/share/aed31fc4c41b32d493b6e006f7415e7e",
      image: ""
    },
    {
      id: 2,
      name: "Using Python to Access Web Data",
      issuer: "Coursera",
      date: "",
      credentialId: "",
      credentialUrl: "https://coursera.org/share/2dcc39673126f43af054209b7987f803",
      image: ""
    },
    {
      id: 3,
      name: "Capstone: Retrieving, Processing, and Visualizing Data with Python",
      issuer: "Coursera",
      date: "",
      credentialId: "",
      credentialUrl: "https://coursera.org/share/7c1d3471d48a6dfb8d21c6ea778220e9",
      image: ""
    },
    {
      id: 4,
      name: "Software Engineering: Modeling Software Systems using UML",
      issuer: "Coursera",
      date: "",
      credentialId: "",
      credentialUrl: "https://coursera.org/share/e6241804f2ac663f9605b7225a93f14e",
      image: ""
    },
    {
      id: 5,
      name: "Using Databases with Python",
      issuer: "Coursera",
      date: "",
      credentialId: "",
      credentialUrl: "https://coursera.org/share/f6d4b99745d0d26d34c7e77356ac4ac2",
      image: ""
    },
    {
      id: 6,
      name: "Programming for Everybody (Getting Started with Python)",
      issuer: "Coursera",
      date: "",
      credentialId: "",
      credentialUrl: "https://coursera.org/share/4731d89fcf317a8918ef11c8eb83b5b8",
      image: ""
    },
    {
      id: 7,
      name: "Java and Object-Oriented Programming",
      issuer: "Coursera",
      date: "",
      credentialId: "",
      credentialUrl: "https://coursera.org/share/9949c5dd2e7f10db08f7d04eb5f2009d",
      image: ""
    },
    {
      id: 8,
      name: "React Native",
      issuer: "Coursera",
      date: "",
      credentialId: "",
      credentialUrl: "https://coursera.org/share/283594205cc3b45d85c12f3e75e6545d",
      image: ""
    },
    {
      id: 9,
      name: "Git and GitHub",
      issuer: "Coursera",
      date: "",
      credentialId: "",
      credentialUrl: "https://coursera.org/share/2b3020a8967f6760890bf99daea68fdc",
      image: ""
    },
    {
      id: 10,
      name: "Cloud Computing",
      issuer: "Coursera",
      date: "",
      credentialId: "",
      credentialUrl: "https://coursera.org/share/91c8592db4d2074063f51f50f0b0ef71",
      image: ""
    },
    {
      id: 11,
      name: "Building Scalable Java Microservices with Spring Boot and Spring Cloud",
      issuer: "Coursera",
      date: "",
      credentialId: "",
      credentialUrl: "https://coursera.org/share/699a97400df614abf583a04dda2b257f",
      image: ""
    },
    {
      id: 12,
      name: "React Basics",
      issuer: "Coursera",
      date: "",
      credentialId: "",
      credentialUrl: "https://coursera.org/share/5c99ef2a6f0c71dd4f1a4d7f128a9295",
      image: ""
    },
    {
      id: 13,
      name: "Machine Learning with Python",
      issuer: "Coursera",
      date: "",
      credentialId: "",
      credentialUrl: "https://coursera.org/share/3b19c21eb2d615320d25e29667bfa5e4",
      image: ""
    },
    {
      id: 14,
      name: "Containers w/ Docker, Kubernetes & OpenShift",
      issuer: "Coursera",
      date: "",
      credentialId: "",
      credentialUrl: "https://coursera.org/share/eb0083921e55a7c9c8d07455c1a15dd1",
      image: ""
    },
    {
      id: 15,
      name: "DevOps",
      issuer: "Coursera",
      date: "",
      credentialId: "",
      credentialUrl: "https://coursera.org/share/b27b7c264b284c57b3481f278d3ccc0f",
      image: ""
    },
    {
      id: 16,
      name: "Python Data Structures",
      issuer: "Coursera",
      date: "",
      credentialId: "",
      credentialUrl: "https://coursera.org/share/28317aa8314172416fa660564e124b70",
      image: ""
    },
    {
      id: 17,
      name: "Agile Development and Scrum",
      issuer: "Coursera",
      date: "",
      credentialId: "",
      credentialUrl: "https://coursera.org/share/45c27b425933d034b00aa84c919f0ebd",
      image: ""
    }
  ]
};

